import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/t/contracts/$snapshotId')({
  validateSearch: (search: Record<string, unknown>) => ({
    review: search.review === true || search.review === 'true',
  }),
  staticData: { breadcrumb: 'Contract Detail', breadcrumbKey: 'K_BREADCRUMB_CONTRACT_DETAIL' },
});
